export default __webpack_public_path__ + "static/media/close.ab25f215.svg";